module.exports = __webpack_public_path__ + "img/cancel.dc9b9cd0.png";